import script from "./MailingListArchive.vue?vue&type=script&lang=ts&setup=true"
export * from "./MailingListArchive.vue?vue&type=script&lang=ts&setup=true"

import "./MailingListArchive.vue?vue&type=style&index=0&id=28217e35&lang=scss"

const __exports__ = script;

export default __exports__